export default __webpack_public_path__ + "static/media/army_122.e5636af5.jpg";